module.exports = __webpack_public_path__ + "img/key-white-r.a5b74053.svg";